import type { BotDifficulty } from './types';

export const MAIN_DECK_SIZE = 40; // champion choisi inclus (la Légende est à part)
export const RUNE_DECK_SIZE = 12;
/** Riftbound : 3 exemplaires maximum d'une même carte dans le deck principal */
export const MAX_COPIES = 3;
export const VICTORY_SCORE = 8;
export const INITIAL_HAND_SIZE = 4;
export const MULLIGAN_COUNT = 2;
export const CHANNEL_PER_TURN = 2;
export const CHANNEL_FIRST_TURN_P2 = 3;

export const DIFFICULTY_LABELS: Record<BotDifficulty, string> = {
  facile: '🟢 Facile',
  normal: '🟡 Normal',
  difficile: '🔴 Difficile',
};

export const AI_PARAMS: Record<
  BotDifficulty,
  {
    maxPlaysPerTurn: number;
    maxAttacksPerTurn: number;
    attackPreference: 'random' | 'strongest' | 'weakest';
    playSpellChance: number;
    moveChance: number;
  }
> = {
  facile: {
    maxPlaysPerTurn: 2,
    maxAttacksPerTurn: 1,
    attackPreference: 'random',
    playSpellChance: 0.5,
    moveChance: 0.4,
  },
  normal: {
    maxPlaysPerTurn: 4,
    maxAttacksPerTurn: 2,
    attackPreference: 'strongest',
    playSpellChance: 0.75,
    moveChance: 0.6,
  },
  difficile: {
    maxPlaysPerTurn: 6,
    maxAttacksPerTurn: 3,
    attackPreference: 'strongest',
    playSpellChance: 1.0,
    moveChance: 0.8,
  },
};

export const DOMAIN_COLORS: Record<string, string> = {
  Fury: '#d74b28',
  Calm: '#2b7fb9',
  Mind: '#6b4bb9',
  Body: '#b97f2b',
  Chaos: '#b92b7f',
  Order: '#2bb97f',
};

export const DOMAIN_EMOJIS: Record<string, string> = {
  Fury: '🔥',
  Calm: '💧',
  Mind: '🔮',
  Body: '💪',
  Chaos: '⚡',
  Order: '✨',
};
